<template>
    <div>
        <div v-if="invited_tus.length > 0">
            <h3>Open Invitations</h3>
            <p class="text-muted">Companies where you have an open invitation.</p>
            <div class="mt-3">
                <IdentityLine 
                    class="mb-2"
                    v-for="(tu, index) in invited_tus" 
                    :key="`${index}_invited_tu`" 
                    :tenantUser="tu"
                    @switch-accounts-clicked="onSwitchAccountClicked"
                    @connect-tu-clicked="onConnectTuClicked"
                ></IdentityLine>
            </div>
        </div>
        <div v-if="connected_tus.length > 0">
            <h3>Active Accounts</h3>
            <p class="text-muted">Companies where you have an account.</p>
            <div class="mt-3">
                <IdentityLine 
                    class="mb-2"
                    v-for="(tu, index) in connected_tus" 
                    :key="`${index}_connected_tu`" 
                    :tenantUser="tu"
                    @switch-accounts-clicked="onSwitchAccountClicked"
                ></IdentityLine>
            </div>
        </div>
        <!-- <div class="mt-4">
            <a @click="onLogoutClicked">Sign out from all</a>
        </div> -->
        <SwitchAccountsConfirm
            ref="switchAccountsConfirm"
        ></SwitchAccountsConfirm>
        <logout-confirm
            ref="logoutConfirm"
        ></logout-confirm>
    </div>
</template>

<script>

import {suppliosApi} from '@/js/api-service'
import IdentityLine from "@/components/auth/identity/IdentityLine.vue";
import SwitchAccountsConfirm from './SwitchAccountsConfirm.vue';

export default {
    name: 'IdentitySelector',
    components: { 
        IdentityLine,
        SwitchAccountsConfirm,
    },
    data: function() {
        return {
            invited_tus: [],
            connected_tus: [],
            errorMsg: 'Error',
            error: false,
        }
    },
    mounted: function() {
        this.getAuthenticationInformation()
    },
    methods: {
        onSwitchAccountClicked(newAccountDashboardUrl) {
            // IdentityLine component passes up the dashboard URL we want to redirect TO for the new account... since it will be a login protected page, we'll then get redirected to login page with next=[dashboardUrl]
            this.$refs.switchAccountsConfirm.logout(newAccountDashboardUrl)
        },
        onLogoutClicked() {
            this.$refs.logoutConfirm.logout()
        },
        onSubmitEmailAddress(e) {
            e.preventDefault();
            this.getIdentities();
        },
        async getAuthenticationInformation() {
            const data = await suppliosApi.auth.getAuthenticationInformation();
            this.connected_tus = data.filter(tu => !tu.invited);
            this.invited_tus = data.filter(tu => tu.invited);
        },
        async onConnectTuClicked(tenantUserId) {
            const success = await suppliosApi.auth.connectTuToCu(tenantUserId);
            if (success) {
                this.getAuthenticationInformation();
                this.$toast.success('User connected successfully!')
            } else {
                this.$toast.error('Error while connecting user! Please make sure your email address is verified. If you continue to have issues, please contact support.')
            }

        }
    }
}
</script>

<style scoped lang="scss">
.authentication-method-card {
    margin-top: 1rem;
}
.authentication-method-card:hover {
    background-color: $gray-100;
}
</style>
